import FilterCriteria__REFACTORED from './container/index';

export default FilterCriteria__REFACTORED;


// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria__REFACTORED/index.js